import { useEffect } from 'react'
import { getLeBuTree, getPartysByBookId, getUsersByPartyId, getPartyUsersByBookId } from '../../../services/sBook/party.service'
                 
import { groupList, isNullUndefined, treeify } from '../../../common/Helpers'
import { useDispatch } from 'react-redux';
import { action_setContractParties, action_setFireContractParties } from '../../../reducers/actions/Book/actions';

const useGetPartyLeBuTree = (bookId, partyArray, selectedPartysList, setPartyArray) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getLeBuTree();
                let response = serviceResponse.data.data;
  
                if (selectedPartysList !== null) {
                    for (let index = 0; index < selectedPartysList.length; index++) {
                        for (let index2 = 0; index2 < response.length; index2++) {
                            if (selectedPartysList[index].id === response[index2].id && selectedPartysList[index].type === response[index2].type) {
                                response.splice(index2, 1);
                                break;
                            }
                        }
                    }
                }

                let response_aux = treeify(response !== null ? response : [], 'id', "parentId", 'children', 'code', 'name')
    
                setPartyArray(response_aux);
            }
            catch (error) {
            }
        }
        
        if (bookId !== null && partyArray === null && selectedPartysList !== null) {
            getData()
        }
    }, [bookId, partyArray, selectedPartysList, setPartyArray]);
}

const useGetContractPartysByBookId = (bookId, partyArray, setPartyArray, setBookPartyList, makeTreeObject, isPanelOpen, automaticParties, fireSet) => {  
    const dispatch = useDispatch();
      
    useEffect(()=> {
        const getData = async () => {
            try {
                if (!isNullUndefined(automaticParties) && automaticParties.length > 0 && fireSet === true) {
                    setPartyArray({data: {succeeded: true, data: automaticParties}});
                    setBookPartyList && setBookPartyList({data: {succeeded: true, data: automaticParties}});

                    dispatch(action_setFireContractParties(false));
                }
                else {
                    let serviceResponse = await getPartysByBookId(bookId);

                    if (makeTreeObject !== undefined && makeTreeObject !== null) {
                        if (makeTreeObject) {
                            serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children');
                        }
                    }

                    setPartyArray(serviceResponse);
                    setBookPartyList && setBookPartyList(serviceResponse);
                    dispatch(action_setFireContractParties(false));
                }
            }
            catch (error) {
                setPartyArray([]);
                setBookPartyList && setBookPartyList([]);
                dispatch(action_setFireContractParties(false));
            }
        }
        
        if (bookId !== null && bookId !== undefined && (partyArray === null || fireSet) && (isPanelOpen || fireSet)) {
            getData()
        }
    }, [bookId, partyArray, setPartyArray, setBookPartyList, makeTreeObject, isPanelOpen, automaticParties, fireSet]);
}

const useGetPartysByBookId = (bookId, partyArray, setPartyArray, setBookPartyList, makeTreeObject, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getPartysByBookId(bookId);

                if (makeTreeObject !== undefined && makeTreeObject !== null) {
                    if (makeTreeObject) {
                        serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children');
                    }
                }

                setPartyArray(serviceResponse);

                setBookPartyList && setBookPartyList(serviceResponse);
            }
            catch (error) {
            }
        }
        
        if (bookId !== null && bookId !== undefined && partyArray === null && isPanelOpen) {
            getData()
        }
    }, [bookId, partyArray, setPartyArray, setBookPartyList, isPanelOpen, makeTreeObject]);
}

const useGetUsersByPartyId = (partyId, partyUserList, setPartyUserList, isPanelOpen, treefy, fireGetPartyUsers) => {    
    useEffect(()=> {
        const getData = async () => {
            try {

                let serviceResponse = await getUsersByPartyId(partyId);

                const response = serviceResponse.data.data;
                

                if (treefy) {
                    let response_aux = treeify(response !== null ? response : [], 'id', null, 'children', "fullname", 'emailuser')
                    setPartyUserList(response_aux);
                } else {
                    setPartyUserList(prevState => ({
                        ...prevState,
                        data: serviceResponse.data.data
                    }));
                }
            }
            catch (error) {
            }
        }
        
        if (treefy) {
            if (partyId !== null && partyUserList === null && isPanelOpen === true && fireGetPartyUsers) {
                getData()
            }   
        } else {
            if (partyId !== null && partyUserList.data === null && isPanelOpen === true && fireGetPartyUsers) {
                getData()
            }
        }

    }, [partyId, partyUserList, setPartyUserList, isPanelOpen, treefy, fireGetPartyUsers]);
}

const useGetPartyUsersByBookId = (bookId, partyUsersList, setPartyUserList, fireGetBookUsers, setFireGetBookUsers, setterUsersBookCount) => {    
    useEffect(()=> {
        const getData = async () => {
            try {

                let serviceResponse = await getPartyUsersByBookId(bookId);

                setPartyUserList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: groupList(serviceResponse.data.data, "username")
                }));
                
                setFireGetBookUsers && setFireGetBookUsers(false);

                setFireGetBookUsers && setterUsersBookCount(serviceResponse.data.data.length)
            }
            catch (error) {
            }
        }
        
        if (bookId !== null && (partyUsersList.data === null || fireGetBookUsers)) {
            getData();
        }
    }, [bookId, partyUsersList, setPartyUserList, fireGetBookUsers, setFireGetBookUsers, setterUsersBookCount]);
}


export {
    useGetPartyLeBuTree,
    useGetUsersByPartyId,
    useGetPartysByBookId,
    useGetPartyUsersByBookId,
    useGetContractPartysByBookId
}